import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'List' })({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        width: '100%'
    }
});
